import { Currency } from "../models/models.swagger.generated";

export class PriceUtils {
  static getPriceWithCurrency(price: number, currency: Currency): string {
    return `${price.toFixed(2)} ${Currency[currency]}`;
  }
}
